'use strict';

var _ = require('lodash');
var moment = require('moment');
var GridColumnValidationService = function GridColumnValidationService(momentService, CommonUiConstants, gridDropdownPopulateService) {
  /**
   *
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isAlphaNumeric(cell, value) {
    var regExp = /^[a-zA-Z\d\s]*$/i;
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }
  function isCommaSeparatedAlphaNumeric(cell, value) {
    var regExp = /^[A-Z0-9$]{1,15}$/;
    return _.isEmpty(value) || _.every(value.split(','), function (eachValue) {
      return !!eachValue.match(regExp);
    });
  }
  function isBothFareChangePercentagePresent(cell, value, row, allRows, cellName) {
    return !!(isNotEmpty(cell, value) && isNotEmpty(cell, row[cellName]) || !isNotEmpty(cell, value) && !isNotEmpty(cell, row[cellName]));
  }
  function isMaxFarePercentageGreaterOrEqualToMinFare(cell, value, row, allRows, cellName) {
    if (!isNotEmpty(cell, value) || !isNotEmpty(cell, !row[cellName])) {
      return true;
    }
    return Number(value) >= Number(row[cellName]);
  }
  function isMinFarePercentageLessOrEqualToMaxFare(cell, value, row, allRows, cellName) {
    if (!isNotEmpty(cell, value) || !isNotEmpty(cell, !row[cellName])) {
      return true;
    }
    return Number(value) <= Number(row[cellName]);
  }
  function isValidEmail(cell, value) {
    var regExp = /^[\w!#$%&'*+/=?`{|}~^-]+(?:\.[\w!#$%f&'*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/i;
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }
  function isValidEmailSemicolonSeparated(cell, value) {
    if (!value) {
      return true;
    }
    var regExp = /^(([\w!#$%&'*+\\=?`{|}~^-]+(?:\.[\w!#$%f&'*+\\=?`{|}~^-]+)*)@(?:[a-zA-Z0-9-]+\.)+([a-zA-Z]{2,6})([;]|$))*$/i;
    return !!value.match(regExp);
  }
  function isValidRegexForFareExclusionRule(cell, value) {
    var regExp = /^[A-Z0-9*%?#]*$/;
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }

  /**
   * Return true if value is a combination of alphabets, numbers, hyphen, commas, spaces
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isValidRegexForFBCIncludeOrExcludePattern(cell, value) {
    var regExp = /^[a-z\d\s\-,]*$/i;
    return !isNotEmpty(cell, value) || regExp.test(value);
  }

  /**
   * Return true if value is a combination of alphabets, numbers, hyphen or regex special chars
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isValidRegexForFBCValues(cell, value) {
    var regExp = /^[a-z\d\-\?\.\*\#\%]{0,8}$/i;
    return !isNotEmpty(cell, value) || regExp.test(value);
  }

  /**
   * Return true if value's length is smaller or equal than maxLength
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param maxLength
   * @returns {boolean}
   */
  function isShorterOrEqualsMaxLength(cell, value, row, allRows, maxLength) {
    return _.isNil(value) || value.length <= parseInt(maxLength, 10);
  }

  /**
   * Return true if value's length is equal or bigger than minLength
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param minLength
   * @returns {boolean}
   */
  function isLongerOrEqualsMinLength(cell, value, row, allRows, minLength) {
    if (!isNotEmpty(cell, value)) {
      return false;
    }
    return parseInt(minLength, 10) <= value.length;
  }

  /**
   * Return true if value's length is equal or bigger than minLength with empty acceptance
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param minLength
   * @returns {boolean}
   */
  function isLongerOrEqualsMinLengthWithAcceptEmpty(cell, value, row, allRows, minLength) {
    if (!isNotEmpty(cell, value)) {
      return true;
    }
    return parseInt(minLength, 10) <= value.length;
  }

  /**
   * Compare two Date objects. Returns true if start date is before or equal to end date
   * @param start
   * @param end
   * @returns {boolean}
   */
  function isDateBeforeOrEqual(start, end) {
    if (start && start.value && end && end.value) {
      if (_.isDate(start.value.toDate()) && _.isDate(end.value.toDate())) {
        return start.value.toDate() <= end.value.toDate();
      }
      return true;
    }
    return true;
  }

  /**
   * Compare two Date objects. Returns true if start date is before end date
   * @param start
   * @param end
   * @returns {boolean}
   */
  function isDateBefore(start, end) {
    if (start && start.value && end && end.value) {
      if (_.isDate(start.value.toDate()) && _.isDate(end.value.toDate())) {
        return start.value.toDate() < end.value.toDate();
      }
      return true;
    }
    return true;
  }
  function isOnOrBeforeCurrentDate(cell, value) {
    if (!value) {
      return false;
    }
    var currentDate = momentService.now(value.config);
    return value.isSame(currentDate, 'day') || value.isAfter(currentDate, 'day');
  }

  /**
   * Return true if value is before value of cellName, or there's no value for both
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isBeforeOrEqualToDateInColumn(cell, value, row, allRows, cellName) {
    return isDateBeforeOrEqual(value, row[cellName]);
  }

  /**
   * Return true if value is after value of cellName, or there's no value for both
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isAfterOrEqualToDateInColumn(cell, value, row, allRows, cellName) {
    return isDateBeforeOrEqual(row[cellName], value);
  }

  /**
   * Return true if value is after value of cellName, replace empty date to some values and then compare
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isBeforeOrEqualToDateInColumnChangeNullToDate(cell, value, row, allRows, cellName, thisCellValueFromNull, thisCellConfig, correspondingCellValueFromNull, correspondingCellConfig) {
    var thisCellValue = value || momentService.of(thisCellValueFromNull, momentService.FIELD[thisCellConfig]);
    var correspondingCellValue = row[cellName] || momentService.of(correspondingCellValueFromNull, momentService.FIELD[correspondingCellConfig]);
    return isDateBeforeOrEqual(thisCellValue, correspondingCellValue);
  }

  /**
   * Return true if value is before value of cellName, replace empty date to some values and then compare
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isAfterOrEqualToDateInColumnChangeNullToDate(cell, value, row, allRows, cellName, thisCellValueFromNull, thisCellConfig, correspondingCellValueFromNull, correspondingCellConfig) {
    var thisCellValue = value || momentService.of(thisCellValueFromNull, momentService.FIELD[thisCellConfig]);
    var correspondingCellValue = row[cellName] || momentService.of(correspondingCellValueFromNull, momentService.FIELD[correspondingCellConfig]);
    return isDateBeforeOrEqual(correspondingCellValue, thisCellValue);
  }

  /**
   * Return true if value is before value of cellName, replace empty date to some values and then compare
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isAfterDateInColumnChangeNullToDate(cell, value, row, allRows, cellName, thisCellValueFromNull, thisCellConfig, correspondingCellValueFromNull, correspondingCellConfig) {
    var thisCellValue = value || momentService.of(thisCellValueFromNull, momentService.FIELD[thisCellConfig]);
    var correspondingCellValue = row[cellName] || momentService.of(correspondingCellValueFromNull, momentService.FIELD[correspondingCellConfig]);
    return isDateBefore(correspondingCellValue, thisCellValue);
  }

  /**
   * Return true if value is between min and max
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param min
   * @param max
   * @returns {boolean}
   */
  function isBetween(cell, value, row, allRows, min, max) {
    return !isNotEmpty(cell, value) || value >= min && value <= max;
  }
  function isValidFiledAmount(cell, value, row, allRows, min) {
    if (isNotEmpty(cell, value)) {
      if (value[0] == '-') {
        return false;
      }
      var values = value.split('-');
      if (values.length == 1) {
        return isGreaterOrEqual(cell, value, row, allRows, min);
      }
      if (values.length > 2) {
        return false;
      }
      return isNumeric(cell, values[0]) && isNumeric(cell, values[1]) && parseFloat(values[0]) < parseFloat(values[1]) && isGreaterOrEqual(cell, values[0], row, allRows, min) && isGreater(cell, values[1], row, allRows, min);
    }
    return true;
  }

  /**
   * Return true if value is between min and max exclusively
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param min
   * @param max
   * @returns {boolean}
   */
  function isBetweenExclusive(cell, value, row, allRows, min, max) {
    return !isNotEmpty(cell, value) || value > min && value < max;
  }

  /**
   * Return true if value is between min and max
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param min
   * @param max
   * @returns {boolean}
   */
  function isBetweenOrEmpty(cell, value, row, allRows, min, max) {
    if (!value) {
      return true;
    }
    return value >= min && value <= max;
  }

  /**
   * Return true if value is between min and max or empty for selected/entered value in row
   * For example: x should be between 0 and 100 only for one specific selected metric
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param min
   * @param max
   * @param specificCell
   * @param specificValue
   * @returns {boolean}
   */
  function isBetweenOrEmptyForSpecificValueInRow(cell, value, row, allRows, min, max, specificCell, specificValue) {
    var currentSpecificValue = _.get(row, specificCell);
    return _.isEqual(currentSpecificValue, specificValue) ? isBetweenOrEmpty(cell, value, row, allRows, min, max) : true;
  }

  /**
   * Return true if value is between min and max for selected/entered value in row
   * For example: x should be between 0 and 100 only for one specific selected metric
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param min
   * @param max
   * @param specificCell
   * @param specificValue
   * @returns {boolean}
   */
  function isBetweenForSpecificValueInRow(cell, value, row, allRows, min, max, specificCell, specificValue) {
    var currentSpecificValue = _.get(row, specificCell);
    return _.isEqual(currentSpecificValue, specificValue) ? isBetween(cell, value, row, allRows, min, max) : true;
  }

  /**
   * Return true if value is equal or greater than min
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param min
   * @returns {boolean}
   */
  function isEqualOrGreater(cell, value, row, allRows, min) {
    return !isNotEmpty(cell, value) || value >= min;
  }

  /**
   * Return true if value is greater than min
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param min
   * @returns {boolean}
   */
  function isGreater(cell, value, row, allRows, min) {
    return !isNotEmpty(cell, value) || value > min;
  }

  /**
   * Return true if value is greater than min
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param min
   * @returns {boolean}
   */
  function isGreaterOrEqual(cell, value, row, allRows, min) {
    return !isNotEmpty(cell, value) || value >= min;
  }

  /**
   * Return true if value is less than max
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param min
   * @returns {boolean}
   */
  function isLess(cell, value, row, allRows, max) {
    return !isNotEmpty(cell, value) || value < max;
  }

  /**
   * Return true if value is equal or less than max
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param max
   * @returns {boolean}
   */
  function isLessOrEqual(cell, value, row, allRows, max) {
    return !isNotEmpty(cell, value) || value <= max;
  }

  /**
   * Return true if value is integer between min and max
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param min
   * @param max
   * @returns {boolean}
   */
  function isIntWithinRange(cell, value, row, allRows, min, max) {
    return !isNotEmpty(cell, value) || value % 1 === 0 && value >= min && value <= max;
  }

  /**
   * Return true if value is integer
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isInt(cell, value) {
    return value % 1 === 0;
  }

  /**
   * Return true if value is integer
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isIntOrEmpty(cell, value) {
    if (!value) {
      return true;
    }
    return value % 1 === 0;
  }

  /**
   * Return true if value is not null and not empty
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param excludeWhiteSpace
   * @returns {boolean}
   */
  function isNotEmpty(cell, value, row, allRows, excludeWhiteSpace) {
    value = _.isString(value) && excludeWhiteSpace ? _.trim(value) : value;
    return !_.isEmpty(value) || _.isNumber(value) || _.isBoolean(value);
  }
  function isFareTypeOrBenchmarkCarrierNotEmpty(cell, value, row, allRows, excludeWhiteSpace) {
    if (row.marketListCategory === 'MONITOR' || row.marketListCategory === 'ADAPTIVE') {
      return true;
    }
    value = _.isString(value) && excludeWhiteSpace ? _.trim(value) : value;
    return !_.isEmpty(value) || _.isNumber(value) || _.isBoolean(value);
  }
  function isTargetFbcNotEmpty(cell, value, row, allRows, excludeWhiteSpace) {
    if (row.adaptivePricingCategory === 'ADAPTIVE' || _.indexOf(row.adaptivePricingCategory, 'ADAPTIVE') !== -1) {
      value = _.isString(value) && excludeWhiteSpace ? _.trim(value) : value;
      return !_.isEmpty(value);
    }
    return true;
  }

  /**
   * Return true if value is not null and not empty
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isNotEmptyOrAlignStrategy(cell, value, row, allRows, field) {
    var isStrategyValid = row.strategy === 'ALIGN' && isNotEmpty(cell, row[field]) ? isNotEmpty(cell, value) : row.strategy === 'ALIGN';
    return isNotEmpty(cell, value) || isStrategyValid;
  }

  /**
   * Return true if value is integer or float number
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isNumeric(cell, value) {
    return _.isNil(value) || isInt(cell, value) || !_.isNaN(value * 1) && _.isNumber(value * 1);
  }
  function isInRangeOfZeroTo9999(cell, value) {
    return !value || value >= 0 && value <= 9999;
  }

  /**
   * Return true if value is greater than another value in the same column
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @param propertyName
   * @returns {boolean}
   */
  function isGreaterThanValueInRow(cell, value, row, allRows, cellName, propertyName) {
    var rowToCompareWith = _.find(allRows, {
      propertyName: propertyName
    });
    return toNumber(value) > toNumber(rowToCompareWith[cellName]);
  }

  /**
   * Return true if value is greater or equal than another value in the same column
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @param propertyName
   * @returns {boolean}
   */
  function isGreaterOrEqualToValueInRow(cell, value, row, allRows, cellName, propertyName) {
    var rowToCompareWith = _.find(allRows, {
      propertyName: propertyName
    });
    return toNumber(value) >= toNumber(rowToCompareWith[cellName]);
  }

  /**
   * Return true if value is less than another value in the same column
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @param propertyName
   * @returns {boolean}
   */
  function isLessThanValueInRow(cell, value, row, allRows, cellName, propertyName) {
    var rowToCompareWith = _.find(allRows, {
      propertyName: propertyName
    });
    return toNumber(value) < toNumber(rowToCompareWith[cellName]);
  }
  function toNumber(val) {
    return _.isNumber(val) ? val : _.toNumber(val);
  }

  /**
   * Return true if value is less or equal than another value in the same column
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @param propertyName
   * @returns {boolean}
   */
  function isLessOrEqualToValueInRow(cell, value, row, allRows, cellName, propertyName) {
    var rowToCompareWith = _.find(allRows, {
      propertyName: propertyName
    });
    return toNumber(value) <= toNumber(rowToCompareWith[cellName]);
  }

  /**
   * Return true if value is greater or equal than another value in the same row
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isGreaterOrEqualToValueInCol(cell, value, row, allRows, cellName, excludeOnEmpty) {
    if (excludeOnEmpty && (!value || !row[cellName])) {
      return true;
    }
    return _.isNil(value) ? true : !isNotEmpty(cell, row[cellName]) || Number(value) >= Number(row[cellName]);
  }

  /**
   * Return true if value is greater or equal than another value in the same row for values that are percentage
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isGreaterOrEqualToValueInColForPercentage(cell, value, row, allRows, cellName) {
    value = value / 100;
    return _.isNil(value) ? true : !isNotEmpty(cell, row[cellName]) || value >= row[cellName];
  }

  /**
   * Return true if value is greater than another value in the same row
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isGreaterToValueInCol(cell, value, row, allRows, cellName) {
    return _.isNil(value) ? true : !isNotEmpty(cell, row[cellName]) || value > row[cellName];
  }

  /**
   * Return true if value is less or equal than another value in the same row
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isLessOrEqualToValueInCol(cell, value, row, allRows, cellName, excludeOnEmpty) {
    if (excludeOnEmpty && (!value || !row[cellName])) {
      return true;
    }
    return !isNotEmpty(cell, row[cellName]) || Number(value) <= Number(row[cellName]);
  }

  /**
   * Return true if value is less or equal than another value in the same row
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isLessOrEqualToValueInColForPercentage(cell, value, row, allRows, cellName) {
    value = value / 100;
    return !isNotEmpty(cell, row[cellName]) || value <= row[cellName];
  }

  /**
   * Return true if value is less than another value in the same row
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isLessToValueInCol(cell, value, row, allRows, cellName) {
    return !isNotEmpty(cell, row[cellName]) || value < row[cellName];
  }

  /**
   * Return true if value is positive number restrict to 10 digits & 2 decimal places
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param maxDP
   * @param min
   * @param maxDigitsNumber
   * @returns {boolean}
   */
  function isValidNumber(cell, value, row, allRows, min, maxDP, maxDigitsNumber) {
    return isGreaterOrEqual(cell, value, row, allRows, min) && isCorrectPrecision(cell, value, row, allRows, maxDP) && isIntegerPartShorterOrEqualsMaxLength(cell, value, row, allRows, maxDigitsNumber);
  }

  /**
   * Return true if value is 3 digit decimal number
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param maxDP
   * @param maxDigitsNumber
   * @returns {boolean}
   */
  function isValidPercentageValue(cell, value, row, allRows, maxDP, maxDigitsNumber) {
    return isIntegerPartShorterOrEqualsMaxLength(cell, value, row, allRows, maxDigitsNumber) && isCorrectPrecision(cell, value, row, allRows, maxDP);
  }

  /**
   * Return true if value has less or equal amount of defined number of digits after decimal mark
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param maxDP
   * @returns {boolean}
   */
  function isCorrectPrecision(cell, value, row, allRows, maxDP) {
    var strValue = _.toString(value);
    var regExp = new RegExp('^(?:\\d+\\.\\d{1,' + maxDP + '}|\\d+)$');
    return !isNotEmpty(cell, strValue) || !!strValue.replace('-', '').match(regExp);
  }
  function isCorrectPrecisionIfNumber(cell, value, row, allRows, maxDP) {
    if (_.isNumber(value)) {
      return isCorrectPrecision(cell, value, row, allRows, maxDP);
    }
    return true;
  }

  /**
   * Return true if value has less or equal amount of defined number of digits before decimal mark
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param maxDigitsNumber
   * @returns {boolean}
   */
  function isIntegerPartShorterOrEqualsMaxLength(cell, value, row, allRows, maxDigitsNumber) {
    var strValue = _.toString(value);
    var regExp = new RegExp('^\\d{1,' + maxDigitsNumber + '}(\\.\\d*)?$');
    return !isNotEmpty(cell, strValue) || !!strValue.replace('-', '').match(regExp);
  }

  /**
   * Return true if value is string with specified length, consisting of only letters
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param length
   * @returns {boolean}
   */
  function isAlphabeticStringWithLength(cell, value, row, allRows, length) {
    var regExp = new RegExp('^[a-z]{' + length + '}$', 'i');
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }
  function isAlphabeticStringUpperCaseWithLength(cell, value, row, allRows, length) {
    var regExp = new RegExp('^[A-Z]{' + length + '}$');
    return !isNotEmpty(cell, value) || value.match(regExp);
  }
  function isAlphabeticStringUpperCaseWithLengthAndHyphen(cell, value, row, allRows, length) {
    var regExp = new RegExp('^[A-Z]{' + length + '}$');
    return !isNotEmpty(cell, value) || value === '-' || value.match(regExp);
  }

  /**
   * Return true if value is string with specified length, consisting of only letters with exceptions
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param length
   * @returns {boolean}
   */
  function isAlphabeticStringWithLengthWithExceptions(cell, value, row, allRows, length, exceptions) {
    return exceptions.indexOf(value) !== -1 || isAlphabeticStringWithLength(cell, value, row, allRows, length);
  }

  /**
   * Return true if value is string, consisting of only letters
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param length
   * @returns {boolean}
   */
  function isAlphabeticString(cell, value) {
    var regExp = new RegExp('^[A-z]+$');
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }

  /**
   * Return true if value is either an alphabet or a hyphen
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param length
   * @returns {boolean}
   */
  function isAlphabetOrHyphen(cell, value) {
    var regExp = new RegExp('^[A-z\-]{1}$');
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }

  /**
   * Return true if value is string with specified length, consisting of only letters
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param length
   * @returns {boolean}
   */
  function isAuthAvailLinkValid(cell, value) {
    var regExp = CommonUiConstants.STRATEGY_ACTION_CLASS_LINK_VALUE_PATTERN;
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }

  /**
   * Return true if value is empty or doesn't match DEFAULT_FARE_VALUE_PATTERN regular expression
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isDefaultFareValid(cell, value) {
    var regExp = CommonUiConstants.DEFAULT_FARE_VALUE_PATTERN;
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }

  /**
   * Checks for invalid class referencing in default fares
   * @param cell
   * @param value
   * @param editedRow
   * @param allRows
   * @return {boolean|Array|Object}
   */
  function isFareNotPresentInOtherRowClass(cell, value, editedRow, allRows) {
    var match = /([A-Z])/g.exec(value);
    if (match !== null) {
      return _.every(allRows, function (row) {
        var classDoesNotMatch = row["class"] !== match[0];
        var marketMatch = editedRow.origin === row.origin && editedRow.destination === row.destination;
        var sposMatch = editedRow.spos === row.spos;
        return marketMatch && sposMatch ? classDoesNotMatch : true;
      });
    }
    return true;
  }

  /**
   * Checks for invalid class referencing in default fares
   * @param cell
   * @param value
   * @param editedRow
   * @param allRows
   * @return {boolean}
   */
  function isClassNotPresentInOthersRowFare(cell, value, editedRow, allRows) {
    var regExp = /([A-Z])/g;
    return _.every(allRows, function (row) {
      if (editedRow.origin !== row.origin || editedRow.destination !== row.destination || editedRow.spos !== row.spos) {
        return true;
      }
      var match = regExp.exec(row.fare);
      if (match !== null) {
        return match[0] !== value;
      }
      return true;
    });
  }

  /**
   * Return true if value is alphanumeric string, with length less than or equal to 40 characters. Some special
   * characters are allowed. This is matching Target.java regex.
   * @param cell
   * @param value
   */
  function isValidBudgetTargetDescription(cell, value) {
    var regExp = CommonUiConstants.BUDGET_TARGET_DESCRIPTION_VALUE_PATTERN;
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }

  /**
   * Return true if valid comma separated carrier codes
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isValidCommaSeparatedCarrierCodes(cell, value) {
    var regExp = CommonUiConstants.COMMA_SEPARATED_CARRIER_CODE_PATTERN;
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }

  /**
   * Return true if valid comma separated airport codes
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isValidCommaSeparatedAirportCodes(cell, value) {
    var regExp = CommonUiConstants.COMMA_SEPARATED_AIRPORT_CODE_PATTERN;
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }
  function isRoutingNumberValid(cell, value) {
    var regExp = CommonUiConstants.POSITIVE_INT_PATTERN;
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }

  /**
   * Return true if Number of carriers is one more than number of via points
   * @param cell
   * @param cellValue
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */

  function isValidCarrierInboundOutbound(cell, cellValue, row, allRows, cellName) {
    if (_.isNil(cellValue) || _.isEmpty(cellValue)) {
      return false;
    }
    var regExp = CommonUiConstants.COMMA_SEPARATED_CARRIER_CODE_PATTERN;
    if (cellValue.match(regExp)) {
      var noOfCarriers = cellValue.split(',').length;
      if (!row[cellName]) {
        return noOfCarriers === 1;
      }
      var noOfStops = row[cellName].split(',').length;
      return noOfCarriers >= 1 && noOfStops === noOfCarriers - 1;
    }
    return true;
  }

  /**
   * Return true if Auth or Avail values are empty
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function authAvailValidation(cell, value, row, allRows, cellName1, cellName2) {
    return value.length === 0 ? true : !(isNotEmpty(cell, row[cellName1]) || isNotEmpty(cell, row[cellName2]));
  }

  /**
   * Return true if value is unique within the same column with same upperBoundRbd
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @returns {boolean}
   */
  function isUniqueInRowUnderSameUpperBoundRbd(cell, value, row, allRows) {
    var allRowsCopy = _.cloneDeep(allRows);
    _.remove(allRowsCopy, function (value, index) {
      return index === cell.row;
    });
    var rowWithDuplicatedValue = _.find(allRowsCopy, function (eachRow) {
      return !_.isNil(eachRow[cell.column]) && eachRow.upperBoundRbd === row.upperBoundRbd && eachRow[cell.column].valueOf() === value.valueOf();
    });
    return _.isUndefined(rowWithDuplicatedValue);
  }

  /**
   * Return true if value is unique within the same column
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @returns {boolean}
   */
  function isUniqueInRow(cell, value, row, allRows) {
    var allRowsCopy = _.cloneDeep(allRows);
    _.remove(allRowsCopy, function (value, index) {
      return index === cell.row;
    });
    var rowWithDuplicatedValue = _.find(allRowsCopy, function (row) {
      return !_.isNil(row[cell.column]) && row[cell.column].valueOf() === value.valueOf();
    });
    return _.isUndefined(rowWithDuplicatedValue);
  }
  function isUniqueInRowCaseInsensitive(cell, value, row, allRows) {
    var allRowsCopy = _.cloneDeep(allRows);
    _.remove(allRowsCopy, function (value, index) {
      return index === cell.row;
    });
    var rowWithDuplicatedValue = _.find(allRowsCopy, function (row) {
      return !_.isNil(row[cell.column]) && _.toUpper(row[cell.column].valueOf().trim()) === _.toUpper(value.valueOf().trim());
    });
    return _.isUndefined(rowWithDuplicatedValue);
  }
  function isUniqueFareChangeDirection(cell, value, row, allRows) {
    var allRowsCopy = _.cloneDeep(allRows);
    _.remove(allRowsCopy, function (value, index) {
      return index === cell.row;
    });
    var rowWithDuplicatedValue = _.find(allRowsCopy, function (row) {
      if (_.isUndefined(row[cell.column]) && _.isUndefined(value)) return true;
      return !_.isNil(row[cell.column]) && !_.isNil(value) && row[cell.column].valueOf() === value.valueOf();
    });
    return _.isUndefined(rowWithDuplicatedValue);
  }
  function isUniqueIntInRow(cell, value, row, allRows) {
    var allRowsCopy = _.cloneDeep(allRows);
    _.remove(allRowsCopy, function (value, index) {
      return index === cell.row;
    });
    var rowWithDuplicatedValue = _.find(allRowsCopy, function (row) {
      return !_.isNil(row[cell.column]) && !_.isNil(value) && row[cell.column].valueOf().toString() === value.valueOf().toString();
    });
    return _.isUndefined(rowWithDuplicatedValue);
  }

  /**
   * Return true if value is unique compering to another value in the same row
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @returns {boolean}
   */
  function isUniqueInCol(cell, value, row, allRows, cellName) {
    return !isNotEmpty(cell, row[cellName]) || value !== row[cellName];
  }

  /**
   * Return true if value is time format HH:MM
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isTimeFormat(cell, value) {
    var regExp = new RegExp('^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$');
    return !isNotEmpty(cell, value) || !!value.toString().match(regExp);
  }

  /**
   * Return true if expression (operator + value) is not < 0
   * Checked when value was edited
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellNameWithOperator
   * @returns {boolean}
   */
  function isValueWithOperatorNotLessThanZero(cell, value, row, allRows, cellNameWithOperator) {
    var operator = row[cellNameWithOperator];
    return !(operator === '<' && value.valueOf() === 0);
  }

  /**
   * Return true if expression (operator + value) is not < 0
   * Checked when operator was edited
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellNameWithOperator
   * @returns {boolean}
   */
  function isOperatorWithValueNotLessThanZero(cell, operator, row, allRows, cellNameWithValue) {
    var value = row[cellNameWithValue];
    return _.isUndefined(value) || !(operator === '<' && value.valueOf() === 0);
  }

  /**
   * Return true if expression is comma separated numbers, like flight numbers
   * Checked when operator was edited
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellNameWithOperator
   * @returns {boolean}
   */
  function isCommaSeparatedNumbers(cell, value) {
    var regExp = new RegExp('^[\\d\\s,]*$');
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }
  function areNumbersLessThanMax(numbers, max) {
    return _.every(numbers, function (number) {
      return number < max;
    });
  }

  /**
   * Return true if expression is comma separated numbers and numbers less than some number
   * Checked when operator was edited
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellNameWithOperator
   * @returns {boolean}
   */
  function isCommaSeparatedNumbersLessThanMax(cell, value, row, allRows, max) {
    if (!isNotEmpty(cell, value)) {
      return true;
    }
    var regExp = new RegExp('^[\\d\\s,]*$');
    var isArray = _.isArray(value);
    var numbers = isArray ? value : value.split(',');
    var commaSeparatedNumbers = isArray ? value.join(',') : value;
    return !isNotEmpty(cell, commaSeparatedNumbers) || !!commaSeparatedNumbers.match(regExp) && areNumbersLessThanMax(numbers, max);
  }

  /**
   * Return true if expression is comma separated numbers, like flight numbers, with some exceptions
   * Checked when operator was edited
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellNameWithOperator
   * @returns {boolean}
   */
  function isCommaSeparatedNumbersWithExceptions(cell, value, row, allRows, exceptions) {
    return exceptions.indexOf(value) !== -1 || isCommaSeparatedNumbers(cell, value);
  }

  /**
   * Return true if value is string with specified length, consisting of only letters
   * @param cell
   * @param value
   * @param length
   * @returns {boolean}
   */
  function isAlphaNumericStringWithMaxLength(cell, value, row, allRows, length) {
    var regExp = new RegExp('^[a-z0-9]{0,' + length + '}$', 'i');
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }

  /**
   * Return true if value is string with exact length, consisting of only letters
   * @param cell
   * @param value
   * @param length
   * @returns {boolean}
   */
  function isAlphaNumericStringWithExactLength(cell, value, row, allRows, length) {
    var regExp = new RegExp('^[a-z0-9]{' + length + '}$', 'i');
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }

  /**
   * Return true if value is string with specified length, consisting of only letters
   * @param cell
   * @param value
   * @param length
   * @returns {boolean}
   */
  function isValidCarrier(cell, value) {
    var regExp = new RegExp('^[A-Za-z0-9]{2}$', 'i');
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }
  function isValidMultiCarrier(cell, value) {
    var isValid = true;
    if (!_.isEmpty(value)) {
      var values = value.split(',');
      var regExp = new RegExp('^[A-Za-z0-9]{2}$', 'i');
      for (var i = 0; i < values.length; i++) {
        isValid = isValid && (_.isEmpty(values[i]) || regExp.test(values[i]));
      }
    }
    return isValid;
  }

  /**
   * Return true if value is string with specified length, consisting of only letters
   * @param cell
   * @param value
   * @param length
   * @returns {boolean}
   */
  function isFareBasisGroupMapping(cell, value) {
    var regExp = new RegExp('^[a-z0-9\,%]*$', 'i');
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }

  /**
   * Return true if value is string with length 7 consisting of 0 and 1 and starting with 1
   * @param cell
   * @param value
   * @param length
   * @returns {boolean}
   */
  function isBenchmarkFareComponentValid(cell, value) {
    var regExp = new RegExp('^[1][0-1]{6}$', 'i');
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }
  function isValidExcludedDaysOfWeek(cell, value) {
    if (!value) {
      return true;
    }
    var regExp = new RegExp('^Su,Mo,Tu,We,Th,Fr,Sa$');
    return !value.match(regExp);
  }

  /**
   * Return true if value is double and greater than or equal to 0
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isAmountValid(cell, value, row) {
    // Validation should Happen on a different method.
    if (row.strategy === 'ALIGN') {
      return true;
    }
    var regExp = CommonUiConstants.POSITIVE_DOUBLE;
    return !isNotEmpty(cell, value) || !!value.toString().match(regExp);
  }

  /**
   * Return true if align strategy value is double number.
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isAlignAmountValid(cell, value, row) {
    if (row.strategy !== 'ALIGN') {
      return true;
    }
    var parsedValue = parseFloat(value);
    return !isNotEmpty(cell, value) || !!parsedValue || parsedValue === 0;
  }

  /**
   * Return true if value and another cell value in the same row are empty
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isValueEmptyWhenAnotherValueInColNotPresent(cell, value, row, allRows, cellName) {
    return !(_.isNil(value) && _.isEmpty(value) && _.isNil(row[cellName]) && _.isEmpty(row[cellName]));
  }

  /**
   * Return true if value is empty and another cell value have value
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isValueEmptyWhenAnotherValueInColIsPresent(cell, value, row, allRows, cellName) {
    return _.isNil(row[cellName]) || _.isEmpty(row[cellName]) || !(_.isNil(value) || _.isEmpty(value));
  }
  function isValuePresentWhenValueInAnotherColIsPresent(cell, value, row, allRows, cellName) {
    return row[cellName] === null || row[cellName] === '' || row[cellName] === undefined || value === null || value === '' || value === undefined;
  }

  /**
   * Return true if comma separated rbds are valid
   * @param cell
   * @param value
   */
  function isValidCommaSeparatedRbd(cell, value) {
    var regExp = CommonUiConstants.COMMA_SEPARATED_RBD_PATTERN;
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }
  function isValidCommaSeparatedCompetitorRbd(cell, value) {
    var regExp = CommonUiConstants.COMMA_SEPARATED_COMPETITOR_RBD_PATTERN;
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }
  function isValidDashRbdForFareSource(cell, value, row) {
    if (row.competitorFareSource && row.competitorFareSource.includes('ATPCO') && value === '-') {
      return false;
    }
    return true;
  }
  function isValidPercentage(cell, value) {
    var regExp = CommonUiConstants.PERCENTAGE_PATTERN;
    return !isNotEmpty(cell, value) || !!value.toString().match(regExp);
  }

  /**
   * Return true if is only the same value in all rows by cellname
   * @param cell
   * @param value
   * @param row
   * @param allRows
   * @param cellName
   * @returns {boolean}
   */
  function isOnlyValueInRow(cell, value, row, allRows, cellName) {
    var allRowsCopy = _.cloneDeep(allRows);
    var uniqueRows = _.chain(allRowsCopy).transform(function (uniqueRows, row) {
      if (!_.isUndefined(row[cellName])) {
        uniqueRows.push(row[cellName]);
      }
      return uniqueRows;
    }, [value]).uniq().value();
    return _.size(uniqueRows) <= 1;
  }

  /**
   * Returns true if value entered by user is valid route
   * @param cell
   * @param value
   */
  function isDiscontinuedRouteValid(cell, value) {
    var regExp = /^[A-Z]{3}((-[A-Z]{3}){1,10}|(-\d{1,4}-[A-Z]{3}){1,10})$/;
    if (isNotEmpty(cell, value)) {
      return !!value.replace(' (all) ', '-').match(regExp);
    } else {
      return false;
    }
  }
  function isOfValueDependingOnColumn(cell, value, row, allRows, dependingCellName, dependingCellValue, currentCellProperValue) {
    return !(!_.isUndefined(row[dependingCellName]) && row[dependingCellName] === dependingCellValue && _.toInteger(value) !== currentCellProperValue);
  }
  function isBetweenStartAndEnd(cell, value, row, allRows, cellName1, cellName2) {
    if (!isNotEmpty(cell, value)) {
      return true;
    }
    return _.isNil(value) ? true : !isNotEmpty(cell, row[cellName1]) || !isNotEmpty(cell, row[cellName2]) || value >= row[cellName1] && value <= row[cellName2];
  }
  function isValidTimeOfDay(cell, value) {
    if (!value) {
      return true;
    }
    var regExp = new RegExp(CommonUiConstants.TIME_OF_DAY_PATTERN);
    return !!value.match(regExp);
  }
  function isValidWeekendDefinition(cell, value) {
    if (!value) {
      return true;
    }
    return checkForConsecutiveDaysOfWeek(value);
  }
  function isUniqueInRowWithValInCol(cell, value, row, allRows, cellName) {
    var allRowsCopy = _.cloneDeep(allRows);
    _.remove(allRowsCopy, function (value, index) {
      return index === cell.row;
    });
    var rowWithDuplicatedValue = _.find(allRowsCopy, function (eachRow) {
      if (row[cellName].includes(',')) {
        var splitFieldByComma = row[cellName].split(',');
        var result = false;
        for (var i = 0; i < splitFieldByComma.length; i++) {
          result = result || !_.isNil(eachRow[cell.column]) && !_.isNil(eachRow[cellName]) && (eachRow[cellName].valueOf().includes(splitFieldByComma[i]) || splitFieldByComma[i].includes(eachRow[cellName].valueOf())) && eachRow[cell.column].valueOf() === value.valueOf();
        }
        return result;
      } else {
        return !_.isNil(eachRow[cell.column]) && !_.isNil(eachRow[cellName]) && (eachRow[cellName].valueOf().includes(row[cellName]) || row[cellName].includes(eachRow[cellName].valueOf())) && eachRow[cell.column].valueOf() === value.valueOf();
      }
    });
    return _.isUndefined(rowWithDuplicatedValue);
  }
  function checkForConsecutiveDaysOfWeek(value) {
    if (value.startsWith('Mo') && value.endsWith('Su')) {
      var count = 0;
      var dowMap = new Map([['Mo', 0], ['Tu', 1], ['We', 2], ['Th', 3], ['Fr', 4], ['Sa', 5], ['Su', 6]]);
      var splitDOW = value.split(',');
      for (var i = 0; i < splitDOW.length - 1; i++) {
        if (dowMap.get(splitDOW[i]) + 1 !== dowMap.get(splitDOW[i + 1])) {
          count = count + 1;
        }
      }
      return count === 0 || count === 1;
    } else {
      return 'Mo,Tu,We,Th,Fr,Sa,Su'.includes(value);
    }
  }

  /**
   * Return true if value is a combination of alphabets, numbers, hyphen or regex special chars
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isValidRegexForFBCPattern(cell, value) {
    var regExp = /^[a-z\d\s\-,\*]{8}$/i;
    return !isNotEmpty(cell, value) || regExp.test(value);
  }
  function isValidPPSAggrStrategyOneCriticalFlight(cell, value, row, allRows, cellName) {
    var criticalFlight = row[cellName];
    if (criticalFlight === 'First' || criticalFlight === 'Second' || criticalFlight === 'Third') {
      return value === 'No action' || value === 'Actual';
    }
    return true;
  }
  function isValidPPSAggrStrategyAllCriticalFlights(cell, value, row, allRows, cellName) {
    var criticalFlight = row[cellName];
    if (criticalFlight === 'All') {
      return value !== 'Actual';
    }
    return true;
  }
  function isValidCriticalFlightActualPPSAggrStrategy(cell, value, row, allRows, cellName) {
    var ppsAggregationStrategy = row[cellName];
    if (ppsAggregationStrategy === 'Actual') {
      return value !== 'All';
    }
    return true;
  }
  function isValidCriticalFlightAvgSumMinMaxPPSAggrStrategy(cell, value, row, allRows, cellName) {
    var ppsAggregationStrategy = row[cellName];
    if (_.includes(['Avg', 'Sum', 'Min', 'Max'], ppsAggregationStrategy)) {
      return value === 'All';
    }
    return true;
  }
  function isValidTacticalFBCPatternConfig(cell, value, row, allRows, cellName) {
    var property = row[cellName];
    if (property === 'fareBrand') {
      var fareBrandRegExp = /^[a-zA-Z\d\s]*$/i;
      return !isNotEmpty(cell, value) || fareBrandRegExp.test(value);
    } else if (property === 'fbcPattern') {
      var fbcPatternRegExp = /^[a-z\d\-\?\.\*\#\%]{0,8}$/i;
      return !isNotEmpty(cell, value) || fbcPatternRegExp.test(value);
    }
    return true;
  }
  function isValidCommaSeparatedFBCPatternConfig(cell, value, row, allRows, cellName) {
    var isValid = true;
    if (!_.isEmpty(value)) {
      var values = value.split(',');
      var fbcPatternRegExp = /^[a-z\d\?\*\#\%]{0,8}$/i;
      for (var i = 0; i < values.length; i++) {
        isValid = isValid && (_.isEmpty(values[i]) || fbcPatternRegExp.test(values[i]));
      }
    }
    return isValid;
  }
  function isValidFbcPattern(cell, value, row, allRows, cellName) {
    var fbcPatternRegExp = /^[a-z\d\?\*\#\%]{0,8}$/i;
    return _.isEmpty(value) || fbcPatternRegExp.test(value);
  }
  function isValidDates(cell, value) {
    if (isNotEmpty(cell, value)) {
      var isValid = true;
      for (var j = 0; j < value.length; j++) {
        var datesList = value[j].split(',');
        for (var i = 0; i < datesList.length; i++) {
          if (_.isEmpty(datesList[i])) {
            return false;
          }
          var values = datesList[i].split('-');
          var datesRegExp = /^((([0-9])|([0-2][0-9])|([3][0-1]))(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC))(\d{4})?$/;
          if (values.length > 2) {
            return false;
          }
          if (values.length == 1) {
            isValid = isValid && datesRegExp.test(values[0]);
          } else {
            isValid = isValid && datesRegExp.test(values[0]) && datesRegExp.test(values[1]);
          }
        }
      }
      return isValid;
    }
    return false;
  }
  function isValidPipeSeperatedDates(cell, value) {
    if (_.isEmpty(value)) {
      return true;
    }
    var values = value.split('|');
    if (values.length > 2) {
      return false;
    }
    return isValidDates(cell, values);
  }
  function isValidSeasonForTacticalFBCPatternConfig(cell, value, row, allRows, cellName, matchField) {
    var property = row[cellName];
    if (property === 'Season') {
      return isNotEmpty(cell, value) && row[matchField].indexOf(value) !== -1;
    }
    return true;
  }
  function isSingleCharacterBasedOnInventoryAssignment(cell, value, row, allRows, cellName) {
    var inventoryAssignmentMethods = ['ENTRY LEVEL RBD', 'RBD TO RBD'];
    if (inventoryAssignmentMethods.includes(row[cellName])) {
      var regExp = new RegExp('^[A-Za-z]{1}$');
      return !isNotEmpty(cell, value) || !!value.match(regExp);
    }
    return true;
  }
  function isSingleCharacterOrDashBasedOnRbdMethod(cell, value, row, allRows, cellName) {
    var inventoryAssignmentMethods = ['ENTRY LEVEL RBD', 'RBD TO RBD', 'FBC MAPPING', 'UPPER BOUND', 'VALUE BASED'];
    if (inventoryAssignmentMethods.includes(row[cellName])) {
      var regExp = new RegExp('^[A-Za-z]{1}$');
      return !isNotEmpty(cell, value) || value === '-' || !!value.match(regExp);
    }
    return true;
  }
  function isCommaSeparatedBasedOnInventoryAssignment(cell, value, row, allRows, cellName) {
    var inventoryAssignmentMethods = ['ORDINAL'];
    if (inventoryAssignmentMethods.includes(row[cellName])) {
      var regExp = new RegExp('^(([A-Za-z]{1})(,[A-Za-z]{1})*)$');
      return !isNotEmpty(cell, value) || !!value.match(regExp);
    }
    return true;
  }
  function isNotEmptyBasedOnInventoryAssignment(cell, value, row, allRows, cellName) {
    if (row[cellName] !== 'ORDINAL') {
      return isNotEmpty(cell, value);
    }
    return true;
  }
  function isValidSponsorFBCPatternConfigMaxLength(cell, value, row, allRows, maxLength) {
    var valueLength = value && value.replace(/\$/g, '').length || 0;
    return !isNotEmpty(cell, value) || valueLength === 0 || valueLength <= parseInt(maxLength, 10);
  }
  function isValidSponsorFBCPatternConfig(cell, value, row, allRows) {
    var regExp = /^[a-z0-9\*]*$/gi;
    return !isNotEmpty(cell, value) || regExp.test(value);
  }
  function isValidTargetFBCPatternConfigMaxLength(cell, value, row, allRows, maxLength) {
    var valueLength = value && value.replace(/\$/g, '').length || 0;
    return !isNotEmpty(cell, value) || valueLength <= parseInt(maxLength, 10);
  }
  function isValidTargetFBCPatternConfig(cell, value, row, allRows) {
    var regExp = /\$[a-z]|\${2}|\$$|[^(A-Za-z0-9\\$)]|\s+/gi;
    return !isNotEmpty(cell, value) || !regExp.test(value);
  }
  function isValidSponsorFBCPatternIndex(cell, value, row, allRows) {
    var allIndexes = value && value.match(/\$\d/g);
    var sponsorIndexes = [];
    if (allIndexes) {
      sponsorIndexes = _.map(allIndexes, function (s) {
        return parseInt(s.slice(1), 10);
      });
    }
    return sponsorIndexes.length < 1 || row.sponsorFareBasisCode.length >= _.max(sponsorIndexes) && _.min(sponsorIndexes) > 0;
  }

  /**
   * Return true if comma separated cabins are valid
   * @param cell
   * @param value
   */
  function isValidCabinList(cell, value) {
    var regExp = CommonUiConstants.COMMA_SEPARATED_CABINS_PATTERN;
    return !isNotEmpty(cell, value) || !!value.match(regExp);
  }

  /**
   * Return true if value is a combination of alphabets, numbers, question mark and percent
   * Max 1 consecutive % allowed
   * Max 2 consecutive ? allowed
   * @param cell
   * @param value
   * @returns {boolean}
   */
  function isFbcPattern(cell, value) {
    if (_.isEmpty(value)) {
      return true;
    }
    var regExp = /^[A-Z0-9?%]*$/;
    var charactersMatch = !!value.match(regExp);
    var questionmarkCondition = !value.match(/\?\?\?/);
    var percentageCondition = !value.match(/%%/);
    return charactersMatch && questionmarkCondition && percentageCondition;
  }
  function isOneNotEmpty(cell, value, row, allRows, cellName) {
    return isNotEmpty(cell, value) || isNotEmpty(cell, row[cellName]);
  }
  function isValidUserValueForOLCGrid(cell, value, row, allRows) {
    if (isNumeric(cell, value)) {
      if (row.attribute === 'Time of Day') {
        return isBetween(cell, value, row, allRows, 0, 100);
      } else if (row.attribute === 'Travel Time' || row.attribute === 'Fare') {
        return isBetween(cell, value, row, allRows, -1, 1);
      }
    }
    return true;
  }
  function isValidDateFormat(cell, value, row, allRows, dateFormat) {
    var date = moment(value, dateFormat, true);
    return date.isValid();
  }
  function isLessOrEqualToDateInRow(cell, value, row, allRows, cellName, propertyName, dateFormat) {
    var rowToCompareWith = _.find(allRows, {
      propertyName: propertyName
    });
    var currentDate = moment(value, dateFormat, true);
    var rowDate = moment(rowToCompareWith[cellName], dateFormat, true);
    return currentDate.isValid() && rowDate.isValid() && currentDate.isBefore(rowDate) || currentDate.isSame(rowDate);
  }
  function isGreaterOrEqualToDateInRow(cell, value, row, allRows, cellName, propertyName, dateFormat) {
    var rowToCompareWith = _.find(allRows, {
      propertyName: propertyName
    });
    var currentDate = moment(value, dateFormat, true);
    var rowDate = moment(rowToCompareWith[cellName], dateFormat, true);
    return currentDate.isValid() && rowDate.isValid() && currentDate.isAfter(rowDate) || currentDate.isSame(rowDate);
  }
  function isValueValid(cell, value, row, allRows, columnId) {
    if (_.isNil(value) || _.isEmpty(value)) {
      return true;
    }
    var allowedValues = gridDropdownPopulateService.getDropdownValues(columnId);
    return allowedValues.includes(value);
  }
  function isMultiValueValid(cell, value, row, allRows, columnId) {
    if (_.isNil(value) || _.isEmpty(value)) {
      return true;
    }
    var allowedValues = gridDropdownPopulateService.getDropdownValues(columnId);
    return _.every(value.split(','), function (eachValue) {
      return allowedValues.includes(eachValue);
    });
  }
  function isNotEmptyRequiredBasedOnRbdMethod(cell, value, row, allRows) {
    var columnId = cell.column;
    if (row.rbdMethod && (checkFieldRequiredForRbdToRbdMethod(row, columnId) || checkFieldRequiredForFbcMappingRbdMethod(row, columnId) || checkFieldRequiredForOrdinalRbdMethod(row, columnId) || checkFieldRequiredForUpperBoundRbdMethod(row, columnId) || checkFieldRequiredForValueBasedRbdMethod(row, columnId))) {
      return isNotEmpty(cell, value, row, allRows, true);
    }
    return true;
  }
  function checkFieldRequiredForRbdToRbdMethod(row, columnId) {
    return ['ENTRY LEVEL RBD', 'RBD TO RBD'].includes(row.rbdMethod) && ['competitorAirline', 'competitorEntryLevelRbd'].includes(columnId);
  }
  function checkFieldRequiredForOrdinalRbdMethod(row, columnId) {
    return row.rbdMethod === 'ORDINAL' && columnId === 'competitorAirline';
  }
  function checkFieldRequiredForFbcMappingRbdMethod(row, columnId) {
    return row.rbdMethod === 'FBC MAPPING' && ['fbcMappingCompetitorAirline', 'fbcMappingCompetitorFbc'].includes(columnId);
  }
  function checkFieldRequiredForUpperBoundRbdMethod(row, columnId) {
    return row.rbdMethod === 'UPPER BOUND' && ['upperBoundFbc', 'upperBoundAmt', 'typeIndicator'].includes(columnId);
  }
  function checkFieldRequiredForValueBasedRbdMethod(row, columnId) {
    return row.rbdMethod === 'VALUE BASED' && ['minFare', 'maxFare', 'currencyType'].includes(columnId);
  }
  return {
    isAlphaNumeric: isAlphaNumeric,
    isCommaSeparatedAlphaNumeric: isCommaSeparatedAlphaNumeric,
    isBothFareChangePercentagePresent: isBothFareChangePercentagePresent,
    isMaxFarePercentageGreaterOrEqualToMinFare: isMaxFarePercentageGreaterOrEqualToMinFare,
    isMinFarePercentageLessOrEqualToMaxFare: isMinFarePercentageLessOrEqualToMaxFare,
    isShorterOrEqualsMaxLength: isShorterOrEqualsMaxLength,
    isLongerOrEqualsMinLength: isLongerOrEqualsMinLength,
    isBeforeOrEqualToDateInColumn: isBeforeOrEqualToDateInColumn,
    isAfterOrEqualToDateInColumn: isAfterOrEqualToDateInColumn,
    isBetween: isBetween,
    isValidFiledAmount: isValidFiledAmount,
    isBetweenExclusive: isBetweenExclusive,
    isBetweenOrEmpty: isBetweenOrEmpty,
    isBetweenOrEmptyForSpecificValueInRow: isBetweenOrEmptyForSpecificValueInRow,
    isEqualOrGreater: isEqualOrGreater,
    isValidNumber: isValidNumber,
    isValidPercentageValue: isValidPercentageValue,
    isGreater: isGreater,
    isGreaterOrEqual: isGreaterOrEqual,
    isLess: isLess,
    isLessOrEqual: isLessOrEqual,
    isIntWithinRange: isIntWithinRange,
    isInt: isInt,
    isNotEmpty: isNotEmpty,
    isNumeric: isNumeric,
    isInRangeOfZeroTo9999: isInRangeOfZeroTo9999,
    isGreaterThanValueInRow: isGreaterThanValueInRow,
    isGreaterOrEqualToValueInRow: isGreaterOrEqualToValueInRow,
    isLessThanValueInRow: isLessThanValueInRow,
    isLessOrEqualToValueInRow: isLessOrEqualToValueInRow,
    isOnOrBeforeCurrentDate: isOnOrBeforeCurrentDate,
    isCorrectPrecision: isCorrectPrecision,
    isCorrectPrecisionIfNumber: isCorrectPrecisionIfNumber,
    isIntegerPartShorterOrEqualsMaxLength: isIntegerPartShorterOrEqualsMaxLength,
    isBetweenForSpecificValueInRow: isBetweenForSpecificValueInRow,
    isAlphabeticStringWithLength: isAlphabeticStringWithLength,
    isAlphabeticStringUpperCaseWithLength: isAlphabeticStringUpperCaseWithLength,
    isAlphabeticStringUpperCaseWithLengthAndHyphen: isAlphabeticStringUpperCaseWithLengthAndHyphen,
    isAlphabeticStringWithLengthWithExceptions: isAlphabeticStringWithLengthWithExceptions,
    isAlphabeticString: isAlphabeticString,
    isLessOrEqualToValueInCol: isLessOrEqualToValueInCol,
    isLessOrEqualToValueInColForPercentage: isLessOrEqualToValueInColForPercentage,
    isLessToValueInCol: isLessToValueInCol,
    isGreaterOrEqualToValueInCol: isGreaterOrEqualToValueInCol,
    isGreaterOrEqualToValueInColForPercentage: isGreaterOrEqualToValueInColForPercentage,
    isGreaterToValueInCol: isGreaterToValueInCol,
    isAuthAvailLinkValid: isAuthAvailLinkValid,
    isDefaultFareValid: isDefaultFareValid,
    isValidExcludedDaysOfWeek: isValidExcludedDaysOfWeek,
    isValidBudgetTargetDescription: isValidBudgetTargetDescription,
    isValidCommaSeparatedCarrierCodes: isValidCommaSeparatedCarrierCodes,
    isValidCommaSeparatedAirportCodes: isValidCommaSeparatedAirportCodes,
    isRoutingNumberValid: isRoutingNumberValid,
    isValidCarrierInboundOutbound: isValidCarrierInboundOutbound,
    authAvailValidation: authAvailValidation,
    isUniqueInRow: isUniqueInRow,
    isUniqueInCol: isUniqueInCol,
    isUniqueInRowUnderSameUpperBoundRbd: isUniqueInRowUnderSameUpperBoundRbd,
    isTimeFormat: isTimeFormat,
    isValueWithOperatorNotLessThanZero: isValueWithOperatorNotLessThanZero,
    isOperatorWithValueNotLessThanZero: isOperatorWithValueNotLessThanZero,
    isBeforeOrEqualToDateInColumnChangeNullToDate: isBeforeOrEqualToDateInColumnChangeNullToDate,
    isAfterOrEqualToDateInColumnChangeNullToDate: isAfterOrEqualToDateInColumnChangeNullToDate,
    isAfterDateInColumnChangeNullToDate: isAfterDateInColumnChangeNullToDate,
    isCommaSeparatedNumbers: isCommaSeparatedNumbers,
    isCommaSeparatedNumbersLessThanMax: isCommaSeparatedNumbersLessThanMax,
    isCommaSeparatedNumbersWithExceptions: isCommaSeparatedNumbersWithExceptions,
    isAlphaNumericStringWithMaxLength: isAlphaNumericStringWithMaxLength,
    isFareBasisGroupMapping: isFareBasisGroupMapping,
    isIntOrEmpty: isIntOrEmpty,
    isAlphabetOrHyphen: isAlphabetOrHyphen,
    isBenchmarkFareComponentValid: isBenchmarkFareComponentValid,
    isAmountValid: isAmountValid,
    isValidRegexForFareExclusionRule: isValidRegexForFareExclusionRule,
    isValueEmptyWhenAnotherValueInColNotPresent: isValueEmptyWhenAnotherValueInColNotPresent,
    isValueEmptyWhenAnotherValueInColIsPresent: isValueEmptyWhenAnotherValueInColIsPresent,
    isValuePresentWhenValueInAnotherColIsPresent: isValuePresentWhenValueInAnotherColIsPresent,
    isValidCommaSeparatedRbd: isValidCommaSeparatedRbd,
    isValidCommaSeparatedCompetitorRbd: isValidCommaSeparatedCompetitorRbd,
    isValidDashRbdForFareSource: isValidDashRbdForFareSource,
    isValidPercentage: isValidPercentage,
    isValidCarrier: isValidCarrier,
    isValidMultiCarrier: isValidMultiCarrier,
    isValidEmail: isValidEmail,
    isNotEmptyOrAlignStrategy: isNotEmptyOrAlignStrategy,
    isOnlyValueInRow: isOnlyValueInRow,
    isValidEmailSemicolonSeparated: isValidEmailSemicolonSeparated,
    isValidRegexForFBCIncludeOrExcludePattern: isValidRegexForFBCIncludeOrExcludePattern,
    isValidRegexForFBCValues: isValidRegexForFBCValues,
    isAlignAmountValid: isAlignAmountValid,
    isValidTimeOfDay: isValidTimeOfDay,
    isValidWeekendDefinition: isValidWeekendDefinition,
    isDiscontinuedRouteValid: isDiscontinuedRouteValid,
    isUniqueFareChangeDirection: isUniqueFareChangeDirection,
    isFareNotPresentInOtherRowClass: isFareNotPresentInOtherRowClass,
    isClassNotPresentInOthersRowFare: isClassNotPresentInOthersRowFare,
    isBetweenStartAndEnd: isBetweenStartAndEnd,
    isOfValueDependingOnColumn: isOfValueDependingOnColumn,
    isValidRegexForFBCPattern: isValidRegexForFBCPattern,
    isValidPPSAggrStrategyOneCriticalFlight: isValidPPSAggrStrategyOneCriticalFlight,
    isValidPPSAggrStrategyAllCriticalFlights: isValidPPSAggrStrategyAllCriticalFlights,
    isValidCriticalFlightActualPPSAggrStrategy: isValidCriticalFlightActualPPSAggrStrategy,
    isValidCriticalFlightAvgSumMinMaxPPSAggrStrategy: isValidCriticalFlightAvgSumMinMaxPPSAggrStrategy,
    isUniqueInRowCaseInsensitive: isUniqueInRowCaseInsensitive,
    isUniqueIntInRow: isUniqueIntInRow,
    isSingleCharacterBasedOnInventoryAssignment: isSingleCharacterBasedOnInventoryAssignment,
    isSingleCharacterOrDashBasedOnRbdMethod: isSingleCharacterOrDashBasedOnRbdMethod,
    isCommaSeparatedBasedOnInventoryAssignment: isCommaSeparatedBasedOnInventoryAssignment,
    isNotEmptyBasedOnInventoryAssignment: isNotEmptyBasedOnInventoryAssignment,
    isValidTacticalFBCPatternConfig: isValidTacticalFBCPatternConfig,
    isValidCommaSeparatedFBCPatternConfig: isValidCommaSeparatedFBCPatternConfig,
    isValidSponsorFBCPatternConfigMaxLength: isValidSponsorFBCPatternConfigMaxLength,
    isValidSponsorFBCPatternConfig: isValidSponsorFBCPatternConfig,
    isValidTargetFBCPatternConfigMaxLength: isValidTargetFBCPatternConfigMaxLength,
    isValidTargetFBCPatternConfig: isValidTargetFBCPatternConfig,
    isValidSponsorFBCPatternIndex: isValidSponsorFBCPatternIndex,
    isValidCabinList: isValidCabinList,
    isFbcPattern: isFbcPattern,
    isAlphaNumericStringWithExactLength: isAlphaNumericStringWithExactLength,
    isLongerOrEqualsMinLengthWithAcceptEmpty: isLongerOrEqualsMinLengthWithAcceptEmpty,
    isValidSeasonForTacticalFBCPatternConfig: isValidSeasonForTacticalFBCPatternConfig,
    isOneNotEmpty: isOneNotEmpty,
    isValidUserValueForOLCGrid: isValidUserValueForOLCGrid,
    isValidDateFormat: isValidDateFormat,
    isLessOrEqualToDateInRow: isLessOrEqualToDateInRow,
    isGreaterOrEqualToDateInRow: isGreaterOrEqualToDateInRow,
    isFareTypeOrBenchmarkCarrierNotEmpty: isFareTypeOrBenchmarkCarrierNotEmpty,
    isValidDates: isValidDates,
    isValidPipeSeperatedDates: isValidPipeSeperatedDates,
    isValidFbcPattern: isValidFbcPattern,
    isValueValid: isValueValid,
    isMultiValueValid: isMultiValueValid,
    isNotEmptyRequiredBasedOnRbdMethod: isNotEmptyRequiredBasedOnRbdMethod,
    isTargetFbcNotEmpty: isTargetFbcNotEmpty
  };
};
GridColumnValidationService.$inject = ['MomentService', 'CommonUiConstants', 'GridDropdownPopulateService'];
module.exports = GridColumnValidationService;